import { useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Monitor, Moon, Sun } from "lucide-react";
import { getStoredTheme, setTheme, type Theme } from "../lib/theme";

const ICONS: Record<Theme, typeof Monitor> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
};

const LABELS: Record<Theme, string> = {
  system: "System",
  light: "Hell",
  dark: "Dunkel",
};

export function ThemeToggle() {
  const [theme, setLocalTheme] = useState<Theme>(getStoredTheme());
  const Icon = ICONS[theme];

  const handle = (next: Theme) => {
    setLocalTheme(next);
    setTheme(next);
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label={`Theme: ${LABELS[theme]}`}
          className="inline-flex h-8 w-8 items-center justify-center rounded-md text-text-secondary transition-colors hover:bg-bg-hover hover:text-text-primary"
        >
          <Icon size={16} />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className="z-dropdown min-w-[140px] rounded-md border border-border-primary bg-bg-elevated p-1 shadow-md animate-fade-in"
        >
          {(Object.keys(LABELS) as Theme[]).map((t) => {
            const ItemIcon = ICONS[t];
            const active = t === theme;
            return (
              <DropdownMenu.Item
                key={t}
                onSelect={() => handle(t)}
                className={`flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors ${
                  active
                    ? "bg-bg-selected text-text-primary"
                    : "text-text-primary hover:bg-bg-hover"
                }`}
              >
                <ItemIcon size={14} />
                {LABELS[t]}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
